import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=5c87f268&"
import script from "./Icon.vue?vue&type=script&lang=ts&"
export * from "./Icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports